/*
 * Dziennik bledow frontu (24.09.2026, spec C:\claude\docs\dziennik-bledow-audytorow.md).
 * Kazdy wyjatek konczy sie polskim komunikatem dla klienta i wpisem wyslanym beaconem
 * do api.php (akcja log_client). Wpis NIE zawiera adresu e-mail, nazwy firmy ani tresci
 * formularza: tylko etap, typ, komunikat techniczny, komunikat pokazany klientowi, kod.
 * Serwer sam przycina pola i pilnuje limitu 30 wpisow na sesje na godzine.
 */
const API_DZIENNIKA = '/wp-content/themes/audytor/api.php';
let wpisowDziennika = 0;

function tokenZAdresu() {
    try {
        const r = new URLSearchParams(window.location.search).get('r');
        return r && /^[a-f0-9]{32}$/.test(r) ? r : '';
    } catch (e) {
        return '';
    }
}

export function zglosBlad(wpis) {
    try {
        if (wpisowDziennika >= 15) return; // limit na jedno otwarcie strony
        wpisowDziennika++;
        const token = tokenZAdresu();
        const tekst = (v) => (v === undefined || v === null ? '' : String(v));
        const body = JSON.stringify({
            action: 'log_client',
            etap: tekst(wpis.etap).slice(0, 60),
            typ: tekst(wpis.typ).slice(0, 40),
            komunikat: tekst(wpis.komunikat).slice(0, 500),
            komunikat_klienta: tekst(wpis.komunikat_klienta).slice(0, 300),
            kod: tekst(wpis.kod).slice(0, 20),
            token: token,
            url: window.location.pathname + (token ? '?r=' + token : '')
        });
        if (navigator.sendBeacon && navigator.sendBeacon(API_DZIENNIKA, new Blob([body], { type: 'text/plain' }))) {
            return;
        }
        fetch(API_DZIENNIKA, { method: 'POST', body: body, keepalive: true, headers: { 'Content-Type': 'text/plain' } }).catch(() => {});
    } catch (e) {
        // dziennik nie moze zepsuc strony
    }
}

function opisBledu(e) {
    if (!e) return 'brak obiektu bledu';
    if (typeof e === 'string') return e;
    return (e.name || 'Error') + ': ' + (e.message || String(e));
}

function zainstalujDziennik() {
    if (window.__dziennikAudytora) return;
    window.__dziennikAudytora = true;
    window.addEventListener('error', (ev) => {
        const plik = ev && ev.filename ? String(ev.filename) : '';
        // Bledy skryptow obcych (GTM, piksel, baner zgody) przychodza jako "Script error."
        // bez pliku albo z obcej domeny. Zapisujemy je osobnym typem, klientowi nic nie mowimy.
        const nasz = plik.indexOf(window.location.origin + '/wp-content/themes/audytor/') === 0;
        zglosBlad({
            etap: 'window.onerror',
            typ: nasz ? 'wyjatek_js' : 'wyjatek_js_obcy',
            komunikat: (ev && ev.message ? ev.message : 'nieznany blad')
                + (plik ? ' w ' + plik.split('?')[0].split('/').pop() + ':' + (ev.lineno || 0) + ':' + (ev.colno || 0) : '')
        });
    });
    window.addEventListener('unhandledrejection', (ev) => {
        zglosBlad({
            etap: 'unhandledrejection',
            typ: 'odrzucona_obietnica',
            komunikat: opisBledu(ev ? ev.reason : null)
        });
    });
}

export function audytor() {
    zainstalujDziennik();
    const form = document.getElementById('analyzeForm');
    if (!form) return; // formularz tylko na stronie glownej (mainsite.php)

    let progress = 0;
    const preloader = document.querySelector('.preloader');
    const preloaderData = document.querySelector('.preloader__data');
    const resultsContainer = document.getElementById('test_results');
    const queryInput = document.getElementById('url'); // id "url" zostaje dla kompatybilnosci z markup/CSS

    const API_URL = 'wp-content/themes/audytor/api.php';

    // Pomiar wlasny (5.08): zdarzenia audytu leca do warstwy danych GTM, skad
    // kontener przekazuje je do GA4 pod nazwa rowna polu "event". Nazwy
    // audit_requested i report_submitted sa juz oczekiwane przez regule
    // wyzwalajaca w kontenerze; audit_completed jest nowe i wymaga poszerzenia
    // wyrazenia w tej regule. Piksel Meta zostaje bez zmian i dziala rownolegle.
    function pushDL(name, params) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(Object.assign({ event: name }, params || {}));
    }

    // Fetch z twardym timeoutem - 6.07 select_place zawiesil sie raz na ~110 s
    // i UI mielil w nieskonczonosc na 10%. Po timeout: czytelny blad + powrot.
    async function apiCall(payload, timeoutMs = 45000) {
        const ctrl = new AbortController();
        const timer = window.setTimeout(() => ctrl.abort(), timeoutMs);
        try {
            let response;
            try {
                response = await fetch(API_URL, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(payload),
                    signal: ctrl.signal
                });
            } catch (e) {
                e.typDziennika = e.name === 'AbortError' ? 'timeout' : 'siec';
                throw e;
            }
            // 24.09.2026: odpowiedz 5xx albo strona bledu zamiast JSON konczyla sie
            // SyntaxError i komunikatem "blad polaczenia", mylacym przy awarii serwera.
            if (!response.ok) {
                const blad = new Error('HTTP ' + response.status);
                blad.name = 'BladHttp';
                blad.typDziennika = response.status >= 500 ? 'http_5xx' : 'http_4xx';
                blad.kod = response.status;
                throw blad;
            }
            let dane;
            try {
                dane = await response.json();
            } catch (e) {
                const blad = new Error('odpowiedz nie jest JSON (' + e.message + ')');
                blad.name = 'BladOdpowiedzi';
                blad.typDziennika = 'odpowiedz_nie_json';
                blad.kod = response.status;
                throw blad;
            }
            if (!dane || typeof dane !== 'object') {
                const blad = new Error('pusta odpowiedz serwera');
                blad.name = 'BladOdpowiedzi';
                blad.typDziennika = 'odpowiedz_pusta';
                blad.kod = response.status;
                throw blad;
            }
            return dane;
        } finally {
            window.clearTimeout(timer);
        }
    }

    // Polski komunikat dla bledu wywolania api.php (klient nigdy nie widzi tekstu przegladarki).
    function komunikatBleduWywolania(e, komunikatCzasu) {
        if (e && e.name === 'AbortError') return komunikatCzasu;
        if (e && ['http_5xx', 'http_4xx', 'odpowiedz_nie_json', 'odpowiedz_pusta'].indexOf(e.typDziennika) !== -1) {
            return 'Serwer audytora odpowiedział nieprawidłowo. Spróbuj ponownie za chwilę.';
        }
        return 'Wystąpił błąd połączenia. Spróbuj ponownie.';
    }

    function zglosBladWywolania(e, etap, komunikatKlienta) {
        zglosBlad({
            etap: etap,
            typ: (e && e.typDziennika) || 'wyjatek_js',
            komunikat: opisBledu(e),
            komunikat_klienta: komunikatKlienta,
            kod: e && e.kod ? e.kod : ''
        });
    }

    // Wyjatek w naszym kodzie (nie w sieci): bez tego ekran zostawal na pasku postepu.
    function bladNiespodziewany(e, etap) {
        const komunikat = 'Coś poszło nie tak po naszej stronie. Wróć i spróbuj ponownie.';
        zglosBlad({ etap: etap, typ: 'wyjatek_js', komunikat: opisBledu(e) + (e && e.stack ? ' | ' + String(e.stack).split('\n').slice(1, 3).join(' ').trim() : ''), komunikat_klienta: komunikat });
        try {
            showFatalError(komunikat);
        } catch (e2) {
            // ekran i tak jest w nieznanym stanie; wpis juz poszedl
        }
    }

    form.addEventListener('submit', (event) => {
        event.preventDefault();
        wyszukaj().catch((e) => bladNiespodziewany(e, 'wyszukiwanie'));
    });

    async function wyszukaj() {
        const query = queryInput.value.trim();

        if (query.length < 3) {
            displayError('Wpisz link do wizytówki albo nazwę firmy i miasto');
            return;
        }
        clearError();

        // Meta Pixel: start audytu to ViewContent, NIE Lead. Lead pada dopiero przy
        // bramce z adresem (poprawione 23.08.2026 - wczesniej kampania optymalizowana
        // pod "Lead" uczylaby sie sciagac klikaczy zamiast osob zostawiajacych adres).
        if (typeof fbq === 'function') {
            fbq('track', 'ViewContent', { content_name: query, content_category: 'gmb_audit' });
        }
        pushDL('audit_requested', { audit_query: query });

        document.querySelector('.app').classList.add('show');
        document.querySelector('body').classList.add('showMenu');
        document.getElementById('siteUrl2').textContent = query;

        // Preloader z licznikiem % startuje dopiero po potwierdzeniu firmy -
        // na etapie wyszukiwania pokazujemy tylko komunikat
        resultsContainer.classList.add('active');

        showStepMessage('Szukam Twojej wizytówki w Google...');

        // Krok 1: znajdz wizytowke (link LUB nazwa+miasto)
        let resolveData;
        try {
            resolveData = await apiCall({ action: 'resolve_place', query: query });
        } catch (e) {
            const komunikat = komunikatBleduWywolania(e, 'Google odpowiada wolniej niż zwykle i przekroczyliśmy limit czasu. Wróć i spróbuj ponownie.');
            zglosBladWywolania(e, 'resolve_place', komunikat);
            showFatalError(komunikat);
            return;
        }

        if (resolveData.status === 'error_alert') {
            showAlertError(resolveData.message);
            return;
        }
        if (resolveData.status !== 'ok' || !resolveData.data || !resolveData.data.candidates) {
            const komunikat = resolveData.message || 'Nie znaleźliśmy takiej wizytówki.';
            if (resolveData.status === 'ok') {
                // status ok bez listy kandydatow: serwer tego nie zapisal, bo nie uznal za blad
                zglosBlad({ etap: 'resolve_place', typ: 'odpowiedz_niepelna', komunikat: 'status ok bez candidates', komunikat_klienta: komunikat });
            }
            showFatalError(komunikat);
            return;
        }

        // Krok 2: potwierdzenie firmy przez usera
        showCandidates(resolveData.data.candidates, query);
    }

    function showCandidates(candidates, query) {
        // Schowaj komunikaty statusu - naklaldaja sie na karty i przechwytuja klik
        resultsContainer.querySelectorAll('.result-message').forEach(m => {
            m.classList.add('hide');
            m.classList.remove('show');
        });

        // Naglowek kroku wyboru firmy - zamiast "Audytuje wizytowke / Teraz wykonuje:"
        setAppHeader(
            candidates.length === 1 ? 'Znaleźliśmy Twoją firmę' : 'Którą firmę mamy zbadać?',
            candidates.length === 1 ? 'Kliknij na wizytówce, żeby potwierdzić i rozpocząć audyt.' : 'Kliknij na wizytówce, żeby rozpocząć audyt.'
        );
        document.querySelector('.app__header').classList.add('stepCandidates');

        const holder = document.createElement('div');
        holder.classList.add('place-candidates');

        candidates.forEach((c) => {
            const card = document.createElement('button');
            card.type = 'button';
            card.classList.add('place-card');
            // Identyfikator wizytowki na karcie: dzieki niemu odnosnik z gotowym
            // raportem klika DOKLADNIE te firme, ktora zostala w nim zapisana,
            // nawet gdy dopasowanie nazwy nie bylo pewne (poprawka 23.08.2026 -
            // wracajacy odbiorca ogladal ponownie ekran wyboru zamiast raportu).
            card.dataset.placeId = c.place_id || '';
            // Tylko karta z pewnym dopasowaniem nazwy moze byc klikniena automatycznie
            // przez odnosnik z tokenem (prefill.js). Reszta czeka na wybor czlowieka.
            if (c.pewny) {
                card.classList.add('place-card--pewny');
            }

            const name = document.createElement('span');
            name.classList.add('place-card__name');
            name.textContent = c.name;

            const address = document.createElement('span');
            address.classList.add('place-card__address');
            address.textContent = c.address;

            const meta = document.createElement('span');
            meta.classList.add('place-card__meta');
            const ratingTxt = c.rating ? ('★ ' + String(c.rating).replace('.', ',') + ' (' + c.reviews + ' opinii)') : 'Brak opinii';
            meta.textContent = (c.category ? c.category + ' · ' : '') + ratingTxt;

            card.appendChild(name);
            card.appendChild(address);
            card.appendChild(meta);

            card.addEventListener('click', () => {
                holder.remove();
                startAudit(c).catch((e) => bladNiespodziewany(e, 'audyt'));
            });

            holder.appendChild(card);
        });

        // Podpowiedz przy zbyt ogolnej nazwie ("alfa szczecin" daje 8 firm "Alfa",
        // a szukanej wsrod nich nie ma) - zgloszenie Marcina 7.10.2026.
        const hint = document.createElement('p');
        hint.classList.add('place-candidates__hint');
        hint.textContent = 'Nie ma Twojej firmy? Dopisz branżę do nazwy albo wklej link z Map Google.';
        holder.appendChild(hint);

        const retry = document.createElement('button');
        retry.type = 'button';
        retry.classList.add('place-candidates__retry');
        retry.textContent = 'Żadna z powyższych - szukaj ponownie';
        retry.addEventListener('click', () => {
            document.querySelector('.app').classList.remove('show');
            document.querySelector('body').classList.remove('showMenu');
            holder.remove();
            resetAppState();
            // Zdejmuje blokade podwojnego audytu z functions.php (inaczej przycisk szary do 90 s)
            form.dispatchEvent(new CustomEvent('audytor:odblokuj'));
            queryInput.focus();
        });
        holder.appendChild(retry);

        resultsContainer.appendChild(holder);
    }

    async function startAudit(candidate) {
        document.getElementById('siteUrl2').textContent = candidate.name;
        setAppHeader('Audytuję wizytówkę', 'Teraz wykonuję:');
        document.querySelector('.app__header').classList.remove('stepCandidates');
        preloader.classList.add('active');
        showStepMessage('Pobieram dane wizytówki...');
        updatePreloaderData(10, 500);

        // Krok 3: pobranie pelnych danych do sesji (1 call Places Details)
        let selectData;
        try {
            selectData = await apiCall({ action: 'select_place', place_id: candidate.place_id });
        } catch (e) {
            const komunikat = komunikatBleduWywolania(e, 'Google odpowiada wolniej niż zwykle i przekroczyliśmy limit czasu. Wróć i spróbuj ponownie.');
            zglosBladWywolania(e, 'select_place', komunikat);
            showFatalError(komunikat);
            return;
        }
        if (selectData.status !== 'ok') {
            showFatalError(selectData.message || 'Nie udało się pobrać danych wizytówki.');
            return;
        }

        // Krok 4: sekwencja audytu
        const actions = [
            { name: 'check_profile_completeness', description: 'Sprawdzam kompletność profilu firmy...' },
            { name: 'check_reviews', description: 'Analizuję opinie i oceny...' },
            { name: 'check_activity', description: 'Oceniam aktywność profilu...' },
            { name: 'check_competitors', description: 'Porównuję z konkurencją w Twojej okolicy...' },
            { name: 'get_summary', description: 'Przygotowuję podsumowanie...' }
        ];

        progress = 10;
        const progressIncrement = 90 / actions.length;

        for (const action of actions) {
            showStepMessage(action.description);

            let data;
            try {
                data = await apiCall({ action: action.name });
            } catch (e) {
                const komunikat = komunikatBleduWywolania(e, 'Audyt trwa dłużej niż zwykle i przekroczyliśmy limit czasu. Wróć i spróbuj ponownie.');
                zglosBladWywolania(e, action.name, komunikat);
                showFatalError(komunikat);
                return;
            }

            if (data.status === 'ok') {
                progress += progressIncrement;
                updatePreloaderData(progress, 1000);
                if (action.name === 'get_summary') {
                    showResults(data);
                    return;
                }
            } else if (data.status === 'error_alert') {
                showAlertError(data.message);
                return;
            } else {
                console.error('Error:', data.message);
                showFatalError(data.message || 'Wystąpił błąd podczas audytu. Spróbuj ponownie.');
                return;
            }
        }
    }

    function setAppHeader(title, label) {
        document.querySelector('.app__testinfoContent h2').textContent = title;
        const stepLabel = document.getElementById('stepLabel');
        if (stepLabel) stepLabel.textContent = label;
    }

    function showStepMessage(text) {
        const messageElement = document.createElement('div');
        messageElement.textContent = text;
        messageElement.classList.add('result-message');
        const previousMessages = resultsContainer.querySelectorAll('.result-message');
        previousMessages.forEach(message => message.classList.add('hide'));
        resultsContainer.appendChild(messageElement);
        window.setTimeout(() => {
            messageElement.classList.add('show');
        }, 100);
    }

    function showFatalError(message) {
        // Wlasny blok (position: static) - .result-message jest absolute i
        // przycisk powrotu nakladal sie na tekst komunikatu
        resultsContainer.querySelectorAll('.result-message').forEach(m => {
            m.classList.add('hide');
            m.classList.remove('show');
        });
        document.querySelector('.app__header').classList.add('stepCandidates');
        setAppHeader('Nie udało się', '');

        const holder = document.createElement('div');
        holder.classList.add('fatal-error');

        const text = document.createElement('p');
        text.classList.add('fatal-error__text');
        text.textContent = message;
        holder.appendChild(text);

        const back = document.createElement('button');
        back.type = 'button';
        back.classList.add('fatal-error__back');
        back.textContent = 'Wróć i spróbuj ponownie';
        back.addEventListener('click', () => {
            document.querySelector('.app').classList.remove('show');
            document.querySelector('body').classList.remove('showMenu');
            resetAppState();
            form.dispatchEvent(new CustomEvent('audytor:odblokuj'));
            queryInput.focus();
        });
        holder.appendChild(back);
        resultsContainer.appendChild(holder);
    }

    function showAlertError(message) {
        document.querySelector('.app').classList.remove('show');
        const errorMessage = document.createElement('div');
        errorMessage.classList.add('error-alert');
        errorMessage.textContent = message;
        document.querySelector('.subpageHeader__text').appendChild(errorMessage);
    }

    function resetAppState() {
        progress = 0;
        preloader.classList.remove('active');
        preloaderData.textContent = '0%';
        resultsContainer.classList.remove('active');
        resultsContainer.querySelectorAll('.result-message, .place-candidates, .place-candidates__retry, .fatal-error').forEach(el => el.remove());
        const finallyEl = document.querySelector('.app__finally');
        if (finallyEl) finallyEl.remove();
        document.querySelector('.app__header').classList.remove('step2', 'stepCandidates');
        setAppHeader('Audytuję wizytówkę', 'Teraz wykonuję:');
    }

    function showResults(data) {
        document.querySelector('.app__header').classList.add('step2');
        document.querySelector('.app__testinfoContent h2').innerHTML = 'Audyt zakończony';

        // Po zakonczeniu audytu pasek postepu musi zniknac. Bez tego zostawal
        // z klasa "active" (zdejmowal ja tylko resetAppState, ktorego ta sciezka
        // nie wywoluje) i zjadal 160 px pustki w karcie naglowka - na telefonie
        // wypychalo to wynik audytu pod krawedz ekranu (pomiar 20.08.2026).
        preloader.classList.remove('active');
        preloaderData.textContent = '0%';
        const etykietaKroku = document.getElementById('stepLabel');
        if (etykietaKroku) etykietaKroku.textContent = '';
        resultsContainer.querySelectorAll('.result-message').forEach(el => el.remove());

        // Wynik dociera do bramki e-mail - stad wiadomo, ilu uzytkownikow widzi
        // rezultat, a ilu z nich zostawia adres (audit_completed -> report_submitted).
        pushDL('audit_completed', {
            audit_score: typeof data.score === 'number' ? data.score : null,
            audit_query: document.getElementById('siteUrl2').textContent
        });

        const results = document.createElement('div');
        results.classList.add('app__finally');
        results.innerHTML = data.data;

        document.querySelector('.app__content').appendChild(results);
        addEmailForm();

        const scroll_to_form = document.querySelector('.app__gotoform');
        if (scroll_to_form) {
            scroll_to_form.addEventListener('click', () => {
                jQuery('.app').animate({ 'scrollTop': (jQuery('#emailForm').offset().top) + 'px' }, 500);
            });
        }

        podepnijSpisTresci(results);
    }

    /**
     * Spis tresci wygladal na nawigacje (numery, wyroznienie, klodki), ale nie byl
     * klikalny - a pozycje zamkniete sa najmocniejsza zacheta do zostawienia adresu
     * (audyt UX 20.08.2026). Pozycja otwarta przewija do swojej sekcji, pozycja
     * z klodka przewija do bramki i podswietla pole adresu.
     */
    function podepnijSpisTresci(zakres) {
        const menu = zakres.querySelector('.finally-menu');
        if (!menu) return;
        menu.classList.add('finally-menu--klikalne');
        menu.addEventListener('click', (zdarzenie) => {
            const pozycja = zdarzenie.target.closest('li');
            if (!pozycja) return;

            if (pozycja.classList.contains('disabled')) {
                przewinDoBramki();
                return;
            }
            const klucz = pozycja.dataset.sekcja;
            const cel = klucz && document.getElementById('sekcja-' + klucz);
            if (cel) {
                cel.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        });
    }

    function przewinDoBramki() {
        const pole = document.querySelector('#emailForm input[type="email"], #emailForm input[name="email"]');
        const formularz = document.getElementById('emailForm');
        if (!formularz) return;
        formularz.scrollIntoView({ behavior: 'smooth', block: 'center' });
        if (!pole) return;
        // Podswietlenie zamiast natychmiastowego focus: na telefonie focus podnosi
        // klawiature i zaslania to, po co odbiorca tu przyszedl.
        pole.classList.add('pole--wskazane');
        window.setTimeout(() => pole.classList.remove('pole--wskazane'), 2200);
    }

    function addEmailForm() {
        const emailForm = document.createElement('div');
        emailForm.classList.add('finally-results__form');

        emailForm.innerHTML = `
            <h3 class="finally-results__intro">Odbierz pełny raport PDF</h3>
            <p class="finally-results__intro">Pełne nazwy konkurentów z okolicy, brakujące kategorie i frazy oraz plan działań krok po kroku.</p>
            <form id="emailForm">
                <div class="emailForm__form">
                    <div class="form-group">
                        <input type="email" id="userEmail" placeholder="Twój adres email" >
                        <div class="error-msg"></div>
                    </div>
                    <div class="form-group checkbox-group">
                        <input type="checkbox" id="rodoConsent" >
                        <label for="rodoConsent"><span>

    Akceptuję <a href="https://audytor.localone.pl/regulamin-uslugi/" target="_blank">Regulamin usługi audytor.localone.pl</a> i wyrażam zgodę na otrzymywanie od "Avangardo sp. z o.o." treści marketingowych i informacji handlowych, dotyczących produktów i usług "Avangardo sp. z o.o." poprzez kontakt e-mailowy.

    <span class="rodo-hidden-element">Możesz nie podawać danych do kontaktu handlowego i marketingowego i uzyskać raport w kwocie 99 zł. W tym celu napisz do nas na kontakt@localone.pl. Administratorem Twoich danych osobowych jest „Avangardo spółka z o.o.", z siedzibą w Szczecinie 70-655, przy ul. Wendy 10 lok. 3C, wpisaną do Krajowego Rejestru Sądowego pod numerem KRS: 0000942472, REGON: 520784536, NIP: 8513268189. Możesz wycofać zgodę w dowolnym momencie, kierując informację na kontakt@localone.pl. Wycofanie zgody nie wpływa na zgodność z prawem działań podjętych na podstawie zgody przed jej wycofaniem. Więcej w <a href="https://audytor.localone.pl/polityka-prywatnosci/" target="_blank">polityce prywatnosci</a>.</span>
                        <a class="rodo-hidden-element-trigger">Rozwiń więcej</a>

                        </span>

                        </label>
                        <div class="error-msg"></div>
                    </div>
                <button type="submit" class="btn mainBtn">Odbieram bezpłatny raport</button>
                </div>
                <div class="emailForm__generator"></div>
            </form>

        `;

        document.querySelector('.finally-results').appendChild(emailForm);

        const emailFormElement = document.getElementById('emailForm');
        const emailInput = document.getElementById('userEmail');
        const rodoConsent = document.getElementById('rodoConsent');
        const rodoHiddenElement = document.querySelector('.rodo-hidden-element');
        const rodoHiddenElementTrigger = document.querySelector('.rodo-hidden-element-trigger');
        rodoHiddenElementTrigger.addEventListener('click', (e) => {
            e.stopImmediatePropagation();
            e.preventDefault();
            rodoHiddenElement.classList.toggle('show');
            if (rodoHiddenElement.classList.contains('show')) {
                rodoHiddenElementTrigger.textContent = 'Zwiń';
            } else {
                rodoHiddenElementTrigger.textContent = 'Rozwiń więcej';
            }
            return false;
        });

        emailFormElement.addEventListener('submit', async (event) => {
            event.preventDefault();
            event.stopPropagation();

            if (!validateEmail(emailInput.value)) {
                showInputError(emailInput, 'Wprowadź poprawny adres email');
                return;
            } else {
                clearInputError(emailInput);
            }

            if (!rodoConsent.checked) {
                showInputError(rodoConsent, 'Aby kontynuować zaznacz to pole');
                return;
            } else {
                clearInputError(rodoConsent);
            }

            const email = emailInput.value;
            const emailForm__generator = document.querySelector('.emailForm__generator');
            const emailForm__form = document.querySelector('.emailForm__form');
            emailForm__form.classList.add('hide');
            emailForm__generator.classList.add('show');

            // Build progress UI using DOM methods (safe, no innerHTML with user data)
            const progressContainer = document.createElement('div');
            progressContainer.className = 'report-progress';

            const barContainer = document.createElement('div');
            barContainer.className = 'report-progress__bar-container';
            const bar = document.createElement('div');
            bar.className = 'report-progress__bar';
            bar.id = 'reportProgressBar';
            bar.style.width = '0%';
            barContainer.appendChild(bar);

            const stepText = document.createElement('p');
            stepText.className = 'report-progress__step';
            stepText.id = 'reportProgressStep';
            stepText.textContent = 'Przygotowywanie...';

            const infoText = document.createElement('p');
            infoText.className = 'report-progress__info';
            infoText.textContent = 'Nie zamykaj tej strony.';

            progressContainer.appendChild(barContainer);
            progressContainer.appendChild(stepText);
            progressContainer.appendChild(infoText);

            emailForm__generator.textContent = '';
            emailForm__generator.appendChild(progressContainer);

            // Start progress polling
            let progressInterval = null;
            let bladPostepuZgloszony = false;
            const progressBar = document.getElementById('reportProgressBar');
            const progressStep = document.getElementById('reportProgressStep');

            progressInterval = setInterval(async () => {
                try {
                    const prog = await apiCall({ action: 'check_progress' }, 10000);
                    if (prog && prog.step) {
                        const pct = prog.percent || Math.round((prog.step / prog.total) * 100);
                        progressBar.style.width = pct + '%';
                        progressStep.textContent = 'Krok ' + prog.step + '/' + prog.total + ': ' + prog.message;
                    }
                } catch (e) {
                    // Pasek postepu jest tylko ozdoba, klient nie dostaje komunikatu.
                    // Do dziennika jeden wpis na probe, bo zapytanie idzie co 1,5 s.
                    if (!bladPostepuZgloszony) {
                        bladPostepuZgloszony = true;
                        zglosBladWywolania(e, 'check_progress', '');
                    }
                }
            }, 1500);

            try {
                // Generowanie raportu (AI + PDF + mail) potrafi trwac >1 min - dlugi timeout
                // Zgoda jedzie do zaplecza jawnie (8.09.2026). Wczesniej serwer nie
                // dostawal jej wcale i wpisywal do rejestru leadow tresc zgody, ktorej
                // nikt nie potwierdzil. Teraz brak tego pola konczy sie odmowa zapisu.
                const data = await apiCall({ action: 'save_email', email: email, consent: true }, 180000);

                clearInterval(progressInterval);

                if (data.status === 'ok') {
                    progressBar.style.width = '100%';

                    // Meta Pixel: TU jest prawdziwy lead - odbiorca zostawil adres.
                    if (typeof fbq === 'function') {
                        fbq('track', 'Lead', {
                            content_name: document.getElementById('siteUrl2').textContent,
                            content_category: 'gmb_audit',
                            status: true
                        });
                    }
                    pushDL('report_submitted', {
                        audit_query: document.getElementById('siteUrl2').textContent
                    });

                    // Naglowek i akapit zachety sa juz nieaktualne po wyslaniu -
                    // zostaje sam komunikat, zeby ekran nie zachecal do czegos,
                    // co wlasnie zostalo zrobione.
                    document.querySelectorAll('.finally-results__intro').forEach((el) => el.remove());

                    // Do 20.08.2026 konczylo sie na zdaniu "raport jest w drodze"
                    // i cisza - w najcieplejszym momencie kontaktu odbiorca nie
                    // wiedzial, co dalej. Teraz pada zapowiedz kontaktu
                    // (decyzja Marcina 20.08).
                    const successMsg = document.createElement('p');
                    successMsg.className = 'success-message';
                    successMsg.textContent = 'Raport został wysłany na Twój adres e-mail.';

                    const nextStep = document.createElement('p');
                    nextStep.className = 'success-next';
                    nextStep.textContent = 'Odezwiemy się z krótkim podsumowaniem: co z tej listy zrobić najpierw. Bez zobowiązań.';

                    emailForm__generator.textContent = '';
                    emailForm__generator.appendChild(successMsg);
                    emailForm__generator.appendChild(nextStep);
                } else {
                    const bladSerwera = new Error(data.message || '');
                    bladSerwera.komunikatSerwera = data.message || 'Nie udało się wysłać raportu. Spróbuj ponownie za chwilę.';
                    throw bladSerwera;
                }
            } catch (error) {
                clearInterval(progressInterval);
                console.error('Error:', error);
                const komunikat = komunikatBleduZapisu(error);
                // Odmowe serwera (status inny niz ok) zapisal juz api.php; tu tylko bledy
                // przegladarki i sieci, ktorych serwer nie widzial.
                if (!(error && error.komunikatSerwera)) {
                    zglosBladWywolania(error, 'save_email', komunikat);
                }
                emailForm__form.classList.remove('hide');
                emailForm__generator.classList.remove('show');
                showInputError(emailInput, komunikat);
            }
        });

        // 24.09.2026: do tej pory klient widzial surowy komunikat przegladarki,
        // np. "Błąd: signal is aborted without reason" po przekroczeniu limitu
        // czasu (wzorzec bledu wychwycony na Radarze). Przekroczenie czasu NIE
        // oznacza porazki: serwer dalej sklada raport i zwykle go wysyla, wiec
        // mowimy wprost, ze raport moze jeszcze dojsc. Komunikaty z naszego
        // zaplecza (status inny niz ok) sa po polsku i przechodza bez zmian.
        function komunikatBleduZapisu(error) {
            if (error && error.komunikatSerwera) {
                return error.komunikatSerwera;
            }
            if (error && error.name === 'AbortError') {
                return 'Przygotowanie raportu trwa dłużej niż zwykle. Sprawdź skrzynkę za kilka minut, raport może jeszcze dotrzeć. Jeśli nie przyjdzie, spróbuj ponownie.';
            }
            if (error && ['http_5xx', 'http_4xx', 'odpowiedz_nie_json', 'odpowiedz_pusta'].indexOf(error.typDziennika) !== -1) {
                return 'Serwer odpowiedział nieprawidłowo. Sprawdź skrzynkę za kilka minut, raport może jeszcze dotrzeć. Jeśli nie przyjdzie, spróbuj ponownie.';
            }
            if (error instanceof TypeError || (error && error.typDziennika === 'siec')) {
                return 'Nie udało się połączyć z serwerem. Sprawdź połączenie z internetem i spróbuj ponownie.';
            }
            return 'Nie udało się wysłać raportu. Spróbuj ponownie za chwilę.';
        }

        function validateEmail(email) {
            const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return re.test(String(email).toLowerCase());
        }

        function showInputError(inputElement, message) {
            const formGroup = inputElement.closest('.form-group');
            const errorElement = formGroup.querySelector('.error-msg');
            errorElement.textContent = message;
            formGroup.classList.add('has-error');
        }

        function clearInputError(inputElement) {
            const formGroup = inputElement.closest('.form-group');
            const errorElement = formGroup.querySelector('.error-msg');
            errorElement.textContent = '';
            formGroup.classList.remove('has-error');
        }
    }

    function displayError(message) {
        clearError();
        const errorElement = document.createElement('p');
        errorElement.textContent = message;
        errorElement.classList.add('error-message');
        form.appendChild(errorElement);
    }

    function clearError() {
        const errorElement = form.querySelector('.error-message');
        if (errorElement) {
            form.removeChild(errorElement);
        }
    }

    function updatePreloaderData(newValue, duration = 500) {
        const currentValue = parseInt(preloaderData.textContent, 10) || 0;
        const steps = duration / 10; // 10 ms na krok
        const increment = (newValue - currentValue) / steps;

        let currentStep = 0;
        const interval = setInterval(() => {
            currentStep++;
            const value = Math.round(currentValue + increment * currentStep);
            preloaderData.textContent = `${value}%`;

            if (currentStep >= steps) {
                clearInterval(interval);
            }
        }, 10); // 10 ms na krok
    }
}
